import { render } from "./change-password.vue?vue&type=template&id=43ad850a&scoped=true"
import script from "./change-password.vue?vue&type=script&lang=js"
export * from "./change-password.vue?vue&type=script&lang=js"

import "./change-password.vue?vue&type=style&index=0&id=43ad850a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ad850a"]])

export default __exports__